"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// this style will be used for any body of text eg modal

var scrollBarBody = function scrollBarBody(_ref) {
  var trackColor = _ref.trackColor,
    thumbColor = _ref.thumbColor,
    thumbHoverColor = _ref.thumbHoverColor;
  return "\n  &::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: ".concat(trackColor, ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ").concat(thumbColor, ";\n    background-clip: padding-box;\n  \n    :hover {\n      background-color: ").concat(thumbHoverColor, ";\n    }\n  }\n");
};
var _default = exports.default = scrollBarBody;